import { describeError } from '../api/client';
import { Icon } from './Icon';
import Illustration from './Illustration';

/**
 * 데이터 화면 공용 오류 상태 (루브릭 F1 · 리뷰 6회차 M20).
 * 서버 응답 오류(5xx)와 연결 실패를 다른 문장으로, 「다시 시도」는 같은 요청을 다시 보낸다.
 * 모의 데이터로 바꾸지 않는다 — 실서버를 계속 쓴다.
 */
export default function ErrorState({ error, onRetry, compact, heading }: {
  error: unknown; onRetry: () => void; compact?: boolean;
  /** 화면 최상위 상태(상세를 못 받음 등)면 제목을 h1 로 — 보이는 모양은 같다(10회차 관찰 ⑥과 같은 종류) */
  heading?: boolean;
}) {
  const { title, why } = describeError(error);
  return (
    <div className={compact ? 'state error-state compact' : 'state error-state'} role="alert">
      {!compact && <Illustration name="error-server" />}
      {heading ? <h1 className="state-title">{title}</h1> : <b>{title}</b>}
      <p>{why}</p>
      <div className="state-actions">
        <button type="button" className="btn sm" onClick={onRetry}><Icon name="refresh" size={16} /> 다시 시도</button>
      </div>
    </div>
  );
}
